// extracted by mini-css-extract-plugin
export default {"menuBlock":"GE-z","title":"HE-z","nav":"IE-z","flexCell":"JE-z","facetLink":"KE-z"};